import React from 'react';
import { Retool } from '../../../../common/components/ui/retool/Retool';

export const Campaigns = () => <Retool url="https://jetcommerce.retool.com/embedded/public/be0dc07b-a86e-4f81-8391-bb6e285f3bb8?_hideNav=true&_hideTimer=true&_embed=true" />;
